(() => {
  'use-strict';

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;
      const template = element.querySelector('template');
      const poster = element.querySelector('.js-media-video-poster');
      const clone = document.importNode(template.content, true);

      poster.addEventListener('click', () => {
        element.classList.remove('-hasPoster');
        element.appendChild(clone);
      });
    });
  }

  Drupal.behaviors.mediaVideoRemote = {
    attach: () => {
      const elements = document.querySelectorAll('.js-media-video-remote');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
